var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow())?_c('a',{staticClass:"link",attrs:{"href":_vm.login}},[_c('v-btn',{staticClass:"text-none",attrs:{"loading":_vm.loading,"color":"primary","block":"","rounded":""}},[_c('b',[_vm._v(_vm._s(_vm.$t('login')))])])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }